import React, {useEffect, useState} from "react";
import {useAppContext} from "../lib/contextLib";
import {onError} from "../lib/errorLib";
import {API} from "aws-amplify";
import {BsPencilSquare} from "react-icons/bs";
import {
    Button,
    Card,
    CardContent,
    Grid,
    Typography
} from "@mui/material";
import {DataGrid, GridToolbarExport} from "@mui/x-data-grid";
import {useHistory} from "react-router-dom";
import {failCommentSummary} from "../lib/util";

export default function Home() {
    const [notes, setNotes] = useState([]);
    const isAuthenticated = !!useAppContext().user;
    const [isLoading, setIsLoading] = useState(true);
    const history = useHistory();

    useEffect(() => {
        async function onLoad() {
            if (!isAuthenticated) {
                return;
            }

            try {
                const notes = await loadNotes();
                setNotes(notes);
            } catch (e) {
                onError(e);
            }
            setIsLoading(false);
        }

        onLoad().then();
    }, [isAuthenticated]);

    const loadNotes = () => {
        return API.get("hqs", "/hqs", {});
    }

    const hqsRow = (row) => {
        const {inspectedUnit, fullAddress} = row.content.a;
        const {nameOfFamily} = row.content;
        const {street1} = fullAddress;
        const date = new Date(row.createdAt).toLocaleString();
        const failComments = failCommentSummary(row.content) ?? "";
        const inspector = row.content.inspector ?? "";
        let inspectionDate = date;
        let inspectionPass = false;
        let complete = false;
        const pha = row.content.pha ?? "";
        if ("formStatus" in row.content) {
            if ("complete" in row.content.formStatus) {
                complete = row.content.formStatus.complete;
            }
        }

        if ("inspectionPass" in row.content.b) {
            inspectionPass = row.content.b.inspectionPass;
        }

        if (row.content.dateOfInspection) {
            inspectionDate = new Date(row.content.dateOfInspection);
        } else if (row.content.inspectionDate) {
            inspectionDate = new Date(row.content.inspectionDate);
        }

        return {
            id: row.hqsId,
            Family: nameOfFamily,
            Address: street1,
            Unit: inspectedUnit,
            PHA: pha,
            Date: date,
            Passed: inspectionPass,
            Complete: complete,
            Inspector: inspector,
            "Fail Comments": failComments,
            "Date of Inspection": inspectionDate,
        };
    };

    const ExportTool = (props) => {
        return (
            <GridToolbarExport
                csvOptions={{
                    allColumns: true,
                    delimiter: '\t',
                    fileName: "inspection-summary-tsv"
                }}
            />
        );
    }

    const renderNotesList = (forms) => {
        const hqsRows = forms.map((row) => (hqsRow(row)));
        return (
            <>
                <Grid
                    container
                    direction={"column"}
                    spacing={2}
                >
                    <Grid item>
                        <Button
                            size={"medium"}
                            variant={"contained"}
                            color={"primary"}
                            startIcon={<BsPencilSquare/>}
                            onClick={(event) => (history.push("/hqs/new"))}
                        >
                            {"New Inspection"}
                        </Button>
                    </Grid>

                    <Grid item>
                        <DataGrid
                            //autoPageSize={true}
                            autoHeight={true}
                            columns={[
                                {field: "Family", flex: 1},
                                {field: "Address", flex: 1},
                                {field: "Unit", flex: 1},
                                {field: "PHA", flex: 1, hide: true},
                                {field: "Date", flex: 1},
                                {field: "Passed", flex: 1, hide: true},
                                {field: "Complete", flex: 1, hide: true},
                                {field: "Inspector", flex: 1, hide: true},
                                {field: "Fail Comments", flex: 1, hide: true},
                                {field: "Date of Inspection", flex: 1, hide: true},
                            ]}
                            rows={hqsRows}
                            onRowClick={(GridRowParams) => (
                                window.open(`hqs/${GridRowParams.id}`, "_blank").focus()
                            )}
                            components={{Toolbar: ExportTool}}
                        />
                    </Grid>
                </Grid>
            </>
        );
    }

    const CardWithContent = ({children}) => {
        return (<>
            <Card>
                <CardContent>
                    {children}
                </CardContent>
            </Card>
        </>);
    };

    function renderLander() {
        return (
            <CardWithContent>
                <Typography variant={"h3"} align={"center"}>Your Inspections</Typography>
                <Typography variant={"body1"} align={"center"}>HQS forms</Typography>
            </CardWithContent>
        );
    }

    function renderNotes() {
        return (
            <CardWithContent>
                <Typography variant={"h3"} align={"center"}>Your Inspections</Typography>
                {!isLoading && renderNotesList(notes)}
            </CardWithContent>
        );
    }

    return (<>
            {isAuthenticated ? renderNotes() : renderLander()}
        </>
    );
}